var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.72727C13 11.1818 7 15 7 15C7 15 1 11.1818 1 6.72727C1 5.20831 1.63214 3.75155 2.75736 2.67748C3.88258 1.60341 5.4087 1 7 1C8.5913 1 10.1174 1.60341 11.2426 2.67748C12.3679 3.75155 13 5.20831 13 6.72727Z",
    stroke: "#105E96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.63636C8.10457 8.63636 9 7.78163 9 6.72727C9 5.67291 8.10457 4.81818 7 4.81818C5.89543 4.81818 5 5.67291 5 6.72727C5 7.78163 5.89543 8.63636 7 8.63636Z",
    stroke: "#105E96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.1eacda373a0df0bd6d1aab2eead47f74.svg";
export { ForwardRef as ReactComponent };